/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    collection: PropTypes.oneOf(['fa', 'yp']),
    icon: PropTypes.string.isRequired,
};

const defaultProps = {
    ...commonDefaultProps,
    collection: 'fa',
    componentClass: 'i',
};

const Icon = (props) => {
    const classNames = [
        props.collection === 'yp'
            ? 'yp_font'
            : 'fa',
        props.collection === 'yp'
            ? `yp_font_${props.icon}`
            : `fa-${props.icon}`,
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        />
    );
};

Icon.propTypes = propTypes;

Icon.defaultProps = defaultProps;

export default Icon;
